import React from 'react';
import css from './work.module.scss';
import MyDigiFlat from "./MyDigiFlat/MyDigiFlat";
import SelfEmployed from "./SelfEmployed/selfEmployed";
import Thales from "./Thales/Thales";

function Work() {
    return (
        <div className={css.container} id='work'>
            <h1>Work</h1>
            <div/>
            <div className={css.projects}>
                <Thales/>
                <SelfEmployed/>
                <MyDigiFlat/>
            </div>
        </div>
    );
}

export default Work;
